// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.cdnfonts.com/css/sf-pro-display);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*! tailwindcss v4.1.4 | MIT License | https://tailwindcss.com */
@layer properties;
*, ::after, ::before, ::backdrop, ::file-selector-button {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  border: 0 solid;
}
html, :host {
  line-height: 1.5;
  -webkit-text-size-adjust: 100%;
  -moz-tab-size: 4;
    -o-tab-size: 4;
       tab-size: 4;
  font-family: var(--default-font-family, ui-sans-serif, system-ui, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji');
  font-feature-settings: var(--default-font-feature-settings, normal);
  font-variation-settings: var(--default-font-variation-settings, normal);
  -webkit-tap-highlight-color: transparent;
}
hr {
  height: 0;
  color: inherit;
  border-top-width: 1px;
}
abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
  text-decoration: underline dotted;
}
h1, h2, h3, h4, h5, h6 {
  font-size: inherit;
  font-weight: inherit;
}
a {
  color: inherit;
  -webkit-text-decoration: inherit;
  text-decoration: inherit;
}
b, strong {
  font-weight: bolder;
}
code, kbd, samp, pre {
  font-family: var(--default-mono-font-family, ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, 'Liberation Mono', 'Courier New', monospace);
  font-feature-settings: var(--default-mono-font-feature-settings, normal);
  font-variation-settings: var(--default-mono-font-variation-settings, normal);
  font-size: 1em;
}
small {
  font-size: 80%;
}
sub, sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}
sub {
  bottom: -0.25em;
}
sup {
  top: -0.5em;
}
table {
  text-indent: 0;
  border-color: inherit;
  border-collapse: collapse;
}
:-moz-focusring {
  outline: auto;
}
progress {
  vertical-align: baseline;
}
summary {
  display: list-item;
}
ol, ul, menu {
  list-style: none;
}
img, svg, video, canvas, audio, iframe, embed, object {
  display: block;
  vertical-align: middle;
}
img, video {
  max-width: 100%;
  height: auto;
}
button, input, select, optgroup, textarea, ::file-selector-button {
  font: inherit;
  font-feature-settings: inherit;
  font-variation-settings: inherit;
  letter-spacing: inherit;
  color: inherit;
  border-radius: 0;
  background-color: transparent;
  opacity: 1;
}
:where(select:is([multiple], [size])) optgroup {
  font-weight: bolder;
}
:where(select:is([multiple], [size])) optgroup option {
  padding-inline-start: 20px;
}
::file-selector-button {
  margin-inline-end: 4px;
}
::-moz-placeholder {
  opacity: 1;
}
::placeholder {
  opacity: 1;
}
@supports (not (-webkit-appearance: -apple-pay-button))  or (contain-intrinsic-size: 1px) {
  ::-moz-placeholder {
    color: currentcolor;
    @supports (color: color-mix(in lab, red, red)) {
      color: color-mix(in oklab, currentcolor 50%, transparent);
    }
  }
  ::placeholder {
    color: currentcolor;
    @supports (color: color-mix(in lab, red, red)) {
      color: color-mix(in oklab, currentcolor 50%, transparent);
    }
  }
}
textarea {
  resize: vertical;
}
::-webkit-search-decoration {
  -webkit-appearance: none;
}
::-webkit-date-and-time-value {
  min-height: 1lh;
  text-align: inherit;
}
::-webkit-datetime-edit {
  display: inline-flex;
}
::-webkit-datetime-edit-fields-wrapper {
  padding: 0;
}
::-webkit-datetime-edit, ::-webkit-datetime-edit-year-field, ::-webkit-datetime-edit-month-field, ::-webkit-datetime-edit-day-field, ::-webkit-datetime-edit-hour-field, ::-webkit-datetime-edit-minute-field, ::-webkit-datetime-edit-second-field, ::-webkit-datetime-edit-millisecond-field, ::-webkit-datetime-edit-meridiem-field {
  padding-block: 0;
}
:-moz-ui-invalid {
  box-shadow: none;
}
button, input:where([type='button'], [type='reset'], [type='submit']), ::file-selector-button {
  -webkit-appearance: button;
     -moz-appearance: button;
          appearance: button;
}
::-webkit-inner-spin-button, ::-webkit-outer-spin-button {
  height: auto;
}
[hidden]:where(:not([hidden='until-found'])) {
  display: none !important;
}
.absolute {
  position: absolute;
}
.fixed {
  position: fixed;
}
.relative {
  position: relative;
}
.static {
  position: static;
}
.inset-0 {
  inset: calc(var(--spacing) * 0);
}
.top-0 {
  top: calc(var(--spacing) * 0);
}
.top-16 {
  top: calc(var(--spacing) * 16);
}
.top-\\[-100px\\] {
  top: -100px;
}
.top-\\[-180px\\] {
  top: -180px;
}
.right-0 {
  right: calc(var(--spacing) * 0);
}
.right-4 {
  right: calc(var(--spacing) * 4);
}
.bottom-\\[-112px\\] {
  bottom: -112px;
}
.left-0 {
  left: calc(var(--spacing) * 0);
}
.left-\\[32px\\] {
  left: 32px;
}
.z-10 {
  z-index: 10;
}
.z-20 {
  z-index: 20;
}
.z-30 {
  z-index: 30;
}
.z-50 {
  z-index: 50;
}
.m-2 {
  margin: calc(var(--spacing) * 2);
}
.m-3 {
  margin: calc(var(--spacing) * 3);
}
.m-4 {
  margin: calc(var(--spacing) * 4);
}
.m-5 {
  margin: calc(var(--spacing) * 5);
}
.m-6 {
  margin: calc(var(--spacing) * 6);
}
.m-8 {
  margin: calc(var(--spacing) * 8);
}
.mx-8 {
  margin-inline: calc(var(--spacing) * 8);
}
.mx-10 {
  margin-inline: calc(var(--spacing) * 10);
}
.mx-auto {
  margin-inline: auto;
}
.my-1 {
  margin-block: calc(var(--spacing) * 1);
}
.my-2 {
  margin-block: calc(var(--spacing) * 2);
}
.my-4 {
  margin-block: calc(var(--spacing) * 4);
}
.my-6 {
  margin-block: calc(var(--spacing) * 6);
}
.my-8 {
  margin-block: calc(var(--spacing) * 8);
}
.my-10 {
  margin-block: calc(var(--spacing) * 10);
}
.mt-1 {
  margin-top: calc(var(--spacing) * 1);
}
.mt-2 {
  margin-top: calc(var(--spacing) * 2);
}
.mt-4 {
  margin-top: calc(var(--spacing) * 4);
}
.mt-6 {
  margin-top: calc(var(--spacing) * 6);
}
.mt-8 {
  margin-top: calc(var(--spacing) * 8);
}
.mt-10 {
  margin-top: calc(var(--spacing) * 10);
}
.mt-12 {
  margin-top: calc(var(--spacing) * 12);
}
.mt-15 {
  margin-top: calc(var(--spacing) * 15);
}
.mr-2 {
  margin-right: calc(var(--spacing) * 2);
}
.mr-3 {
  margin-right: calc(var(--spacing) * 3);
}
.mr-4 {
  margin-right: calc(var(--spacing) * 4);
}
.mr-5 {
  margin-right: calc(var(--spacing) * 5);
}
.mr-8 {
  margin-right: calc(var(--spacing) * 8);
}
.mr-20 {
  margin-right: calc(var(--spacing) * 20);
}
.mb-1 {
  margin-bottom: calc(var(--spacing) * 1);
}
.mb-2 {
  margin-bottom: calc(var(--spacing) * 2);
}
.mb-3 {
  margin-bottom: calc(var(--spacing) * 3);
}
.mb-4 {
  margin-bottom: calc(var(--spacing) * 4);
}
.mb-5 {
  margin-bottom: calc(var(--spacing) * 5);
}
.mb-6 {
  margin-bottom: calc(var(--spacing) * 6);
}
.mb-8 {
  margin-bottom: calc(var(--spacing) * 8);
}
.mb-10 {
  margin-bottom: calc(var(--spacing) * 10);
}
.mb-12 {
  margin-bottom: calc(var(--spacing) * 12);
}
.mb-20 {
  margin-bottom: calc(var(--spacing) * 20);
}
.mb-\\[-90px\\] {
  margin-bottom: -90px;
}
.ml-4 {
  margin-left: calc(var(--spacing) * 4);
}
.ml-8 {
  margin-left: calc(var(--spacing) * 8);
}
.ml-10 {
  margin-left: calc(var(--spacing) * 10);
}
.ml-45 {
  margin-left: calc(var(--spacing) * 45);
}
.block {
  display: block;
}
.contents {
  display: contents;
}
.flex {
  display: flex;
}
.grid {
  display: grid;
}
.hidden {
  display: none;
}
.inline-flex {
  display: inline-flex;
}
.h-4 {
  height: calc(var(--spacing) * 4);
}
.h-5 {
  height: calc(var(--spacing) * 5);
}
.h-5\\/6 {
  height: calc(5/6 * 100%);
}
.h-8 {
  height: calc(var(--spacing) * 8);
}
.h-12 {
  height: calc(var(--spacing) * 12);
}
.h-14 {
  height: calc(var(--spacing) * 14);
}
.h-16 {
  height: calc(var(--spacing) * 16);
}
.h-20 {
  height: calc(var(--spacing) * 20);
}
.h-24 {
  height: calc(var(--spacing) * 24);
}
.h-30 {
  height: calc(var(--spacing) * 30);
}
.h-\\[40px\\] {
  height: 40px;
}
.h-\\[65px\\] {
  height: 65px;
}
.h-\\[100px\\] {
  height: 100px;
}
.h-\\[150px\\] {
  height: 150px;
}
.h-\\[200px\\] {
  height: 200px;
}
.h-\\[300px\\] {
  height: 300px;
}
.h-\\[330px\\] {
  height: 330px;
}
.h-\\[390px\\] {
  height: 390px;
}
.h-\\[400px\\] {
  height: 400px;
}
.h-\\[600px\\] {
  height: 600px;
}
.h-auto {
  height: auto;
}
.h-fit {
  height: -moz-fit-content;
  height: fit-content;
}
.h-full {
  height: 100%;
}
.h-screen {
  height: 100vh;
}
.max-h-\\[800px\\] {
  max-height: 800px;
}
.min-h-16 {
  min-height: calc(var(--spacing) * 16);
}
.min-h-\\[500px\\] {
  min-height: 500px;
}
.min-h-\\[3100px\\] {
  min-height: 3100px;
}
.w-4 {
  width: calc(var(--spacing) * 4);
}
.w-5 {
  width: calc(var(--spacing) * 5);
}
.w-8 {
  width: calc(var(--spacing) * 8);
}
.w-11\\/12 {
  width: calc(11/12 * 100%);
}
.w-40 {
  width: calc(var(--spacing) * 40);
}
.w-44 {
  width: calc(var(--spacing) * 44);
}
.w-54 {
  width: calc(var(--spacing) * 54);
}
.w-55 {
  width: calc(var(--spacing) * 55);
}
.w-\\[80px\\] {
  width: 80px;
}
.w-\\[100px\\] {
  width: 100px;
}
.w-\\[150px\\] {
  width: 150px;
}
.w-\\[180px\\] {
  width: 180px;
}
.w-\\[200px\\] {
  width: 200px;
}
.w-\\[220px\\] {
  width: 220px;
}
.w-\\[250px\\] {
  width: 250px;
}
.w-\\[300px\\] {
  width: 300px;
}
.w-\\[330px\\] {
  width: 330px;
}
.w-\\[350px\\] {
  width: 350px;
}
.w-\\[400px\\] {
  width: 400px;
}
.w-\\[420px\\] {
  width: 420px;
}
.w-\\[450px\\] {
  width: 450px;
}
.w-\\[470px\\] {
  width: 470px;
}
.w-\\[600px\\] {
  width: 600px;
}
.w-\\[700px\\] {
  width: 700px;
}
.w-\\[778px\\] {
  width: 778px;
}
.w-\\[800px\\] {
  width: 800px;
}
.w-\\[900px\\] {
  width: 900px;
}
.w-auto {
  width: auto;
}
.w-fit {
  width: -moz-fit-content;
  width: fit-content;
}
.w-full {
  width: 100%;
}
.max-w-md {
  max-width: var(--container-md);
}
.min-w-\\[300px\\] {
  min-width: 300px;
}
.flex-1 {
  flex: 1;
}
.transform {
  transform: var(--tw-rotate-x,) var(--tw-rotate-y,) var(--tw-rotate-z,) var(--tw-skew-x,) var(--tw-skew-y,);
}
.cursor-pointer {
  cursor: pointer;
}
.grid-cols-1 {
  grid-template-columns: repeat(1, minmax(0, 1fr));
}
.flex-col {
  flex-direction: column;
}
.flex-row {
  flex-direction: row;
}
.items-center {
  align-items: center;
}
.items-start {
  align-items: flex-start;
}
.justify-around {
  justify-content: space-around;
}
.justify-between {
  justify-content: space-between;
}
.justify-center {
  justify-content: center;
}
.justify-end {
  justify-content: flex-end;
}
.justify-start {
  justify-content: flex-start;
}
.gap-1 {
  gap: calc(var(--spacing) * 1);
}
.gap-2 {
  gap: calc(var(--spacing) * 2);
}
.gap-4 {
  gap: calc(var(--spacing) * 4);
}
.gap-6 {
  gap: calc(var(--spacing) * 6);
}
.gap-8 {
  gap: calc(var(--spacing) * 8);
}
.space-y-2 {
  :where(& > :not(:last-child)) {
    --tw-space-y-reverse: 0;
    margin-block-start: calc(calc(var(--spacing) * 2) * var(--tw-space-y-reverse));
    margin-block-end: calc(calc(var(--spacing) * 2) * calc(1 - var(--tw-space-y-reverse)));
  }
}
.space-y-4 {
  :where(& > :not(:last-child)) {
    --tw-space-y-reverse: 0;
    margin-block-start: calc(calc(var(--spacing) * 4) * var(--tw-space-y-reverse));
    margin-block-end: calc(calc(var(--spacing) * 4) * calc(1 - var(--tw-space-y-reverse)));
  }
}
.space-y-6 {
  :where(& > :not(:last-child)) {
    --tw-space-y-reverse: 0;
    margin-block-start: calc(calc(var(--spacing) * 6) * var(--tw-space-y-reverse));
    margin-block-end: calc(calc(var(--spacing) * 6) * calc(1 - var(--tw-space-y-reverse)));
  }
}
.space-x-3 {
  :where(& > :not(:last-child)) {
    --tw-space-x-reverse: 0;
    margin-inline-start: calc(calc(var(--spacing) * 3) * var(--tw-space-x-reverse));
    margin-inline-end: calc(calc(var(--spacing) * 3) * calc(1 - var(--tw-space-x-reverse)));
  }
}
.space-x-4 {
  :where(& > :not(:last-child)) {
    --tw-space-x-reverse: 0;
    margin-inline-start: calc(calc(var(--spacing) * 4) * var(--tw-space-x-reverse));
    margin-inline-end: calc(calc(var(--spacing) * 4) * calc(1 - var(--tw-space-x-reverse)));
  }
}
.gap-y-2 {
  row-gap: calc(var(--spacing) * 2);
}
.gap-y-4 {
  row-gap: calc(var(--spacing) * 4);
}
.overflow-visible {
  overflow: visible;
}
.overflow-y-auto {
  overflow-y: auto;
}
.rounded-2xl {
  border-radius: var(--radius-2xl);
}
.rounded-3xl {
  border-radius: var(--radius-3xl);
}
.rounded-full {
  border-radius: calc(infinity * 1px);
}
.rounded-lg {
  border-radius: var(--radius-lg);
}
.rounded-md {
  border-radius: var(--radius-md);
}
.rounded-xl {
  border-radius: var(--radius-xl);
}
.rounded-xs {
  border-radius: var(--radius-xs);
}
.rounded-b-lg {
  border-bottom-right-radius: var(--radius-lg);
  border-bottom-left-radius: var(--radius-lg);
}
.border {
  border-style: var(--tw-border-style);
  border-width: 1px;
}
.border-2 {
  border-style: var(--tw-border-style);
  border-width: 2px;
}
.border-l-20 {
  border-left-style: var(--tw-border-style);
  border-left-width: 20px;
}
.border-none {
  --tw-border-style: none;
  border-style: none;
}
.border-\\[\\#0E2D60\\] {
  border-color: #0E2D60;
}
.border-\\[\\#0f3ca3\\] {
  border-color: #0f3ca3;
}
.border-\\[\\#144dd2\\] {
  border-color: #144dd2;
}
.border-\\[\\#1553E0\\] {
  border-color: #1553E0;
}
.border-\\[\\#1553E099\\] {
  border-color: #1553E099;
}
.border-\\[\\#1553E099\\]\\/60 {
  border-color: color-mix(in oklab, #1553E099 60%, transparent);
}
.border-\\[\\#887443\\] {
  border-color: #887443;
}
.border-\\[\\#88744366\\]\\/40 {
  border-color: color-mix(in oklab, #88744366 40%, transparent);
}
.border-black {
  border-color: var(--color-black);
}
.border-blue-500 {
  border-color: var(--color-blue-500);
}
.border-gray-100 {
  border-color: var(--color-gray-100);
}
.border-gray-300 {
  border-color: var(--color-gray-300);
}
.bg-\\[\\#0E2D60\\] {
  background-color: #0E2D60;
}
.bg-\\[\\#9B7B2F\\] {
  background-color: #9B7B2F;
}
.bg-\\[\\#112d6f\\] {
  background-color: #112d6f;
}
.bg-\\[\\#02000E\\] {
  background-color: #02000E;
}
.bg-\\[\\#081533\\] {
  background-color: #081533;
}
.bg-\\[\\#887443\\] {
  background-color: #887443;
}
.bg-\\[\\#887443\\]\\/10 {
  background-color: color-mix(in oklab, #887443 10%, transparent);
}
.bg-\\[\\#887443\\]\\/20 {
  background-color: color-mix(in oklab, #887443 20%, transparent);
}
.bg-\\[\\#887443\\]\\/70 {
  background-color: color-mix(in oklab, #887443 70%, transparent);
}
.bg-\\[\\#887443\\]\\/80 {
  background-color: color-mix(in oklab, #887443 80%, transparent);
}
.bg-\\[\\#FAFAFA\\] {
  background-color: #FAFAFA;
}
.bg-\\[\\#FAFAFA\\]\\/5 {
  background-color: color-mix(in oklab, #FAFAFA 5%, transparent);
}
.bg-\\[\\#FAFAFA\\]\\/10 {
  background-color: color-mix(in oklab, #FAFAFA 10%, transparent);
}
.bg-blue-50 {
  background-color: var(--color-blue-50);
}
.bg-transparent {
  background-color: transparent;
}
.bg-white {
  background-color: var(--color-white);
}
.bg-gradient-to-r {
  --tw-gradient-position: to right in oklab;
  background-image: linear-gradient(var(--tw-gradient-stops));
}
.from-\\[\\#081533\\] {
  --tw-gradient-from: #081533;
  --tw-gradient-stops: var(--tw-gradient-via-stops, var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-to) var(--tw-gradient-to-position));
}
.via-\\[\\#081533\\] {
  --tw-gradient-via: #081533;
  --tw-gradient-via-stops: var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-via) var(--tw-gradient-via-position), var(--tw-gradient-to) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-via-stops);
}
.to-\\[\\#1553E0\\] {
  --tw-gradient-to: #1553E0;
  --tw-gradient-stops: var(--tw-gradient-via-stops, var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-to) var(--tw-gradient-to-position));
}
.to-\\[\\#081533\\] {
  --tw-gradient-to: #081533;
  --tw-gradient-stops: var(--tw-gradient-via-stops, var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-to) var(--tw-gradient-to-position));
}
.p-1 {
  padding: calc(var(--spacing) * 1);
}
.p-2 {
  padding: calc(var(--spacing) * 2);
}
.p-3 {
  padding: calc(var(--spacing) * 3);
}
.p-4 {
  padding: calc(var(--spacing) * 4);
}
.p-5 {
  padding: calc(var(--spacing) * 5);
}
.p-6 {
  padding: calc(var(--spacing) * 6);
}
.p-8 {
  padding: calc(var(--spacing) * 8);
}
.p-10 {
  padding: calc(var(--spacing) * 10);
}
.p-16 {
  padding: calc(var(--spacing) * 16);
}
.p-20 {
  padding: calc(var(--spacing) * 20);
}
.px-2 {
  padding-inline: calc(var(--spacing) * 2);
}
.px-3 {
  padding-inline: calc(var(--spacing) * 3);
}
.px-4 {
  padding-inline: calc(var(--spacing) * 4);
}
.px-6 {
  padding-inline: calc(var(--spacing) * 6);
}
.px-8 {
  padding-inline: calc(var(--spacing) * 8);
}
.px-9 {
  padding-inline: calc(var(--spacing) * 9);
}
.px-10 {
  padding-inline: calc(var(--spacing) * 10);
}
.px-20 {
  padding-inline: calc(var(--spacing) * 20);
}
.py-0 {
  padding-block: calc(var(--spacing) * 0);
}
.py-2 {
  padding-block: calc(var(--spacing) * 2);
}
.py-3 {
  padding-block: calc(var(--spacing) * 3);
}
.py-4 {
  padding-block: calc(var(--spacing) * 4);
}
.py-5 {
  padding-block: calc(var(--spacing) * 5);
}
.py-8 {
  padding-block: calc(var(--spacing) * 8);
}
.py-10 {
  padding-block: calc(var(--spacing) * 10);
}
.py-16 {
  padding-block: calc(var(--spacing) * 16);
}
.pt-6 {
  padding-top: calc(var(--spacing) * 6);
}
.pl-2 {
  padding-left: calc(var(--spacing) * 2);
}
.text-center {
  text-align: center;
}
.text-justify {
  text-align: justify;
}
.text-left {
  text-align: left;
}
.text-start {
  text-align: start;
}
.text-2xl {
  font-size: var(--text-2xl);
  line-height: var(--tw-leading, var(--text-2xl--line-height));
}
.text-3xl {
  font-size: var(--text-3xl);
  line-height: var(--tw-leading, var(--text-3xl--line-height));
}
.text-4xl {
  font-size: var(--text-4xl);
  line-height: var(--tw-leading, var(--text-4xl--line-height));
}
.text-5xl {
  font-size: var(--text-5xl);
  line-height: var(--tw-leading, var(--text-5xl--line-height));
}
.text-base {
  font-size: var(--text-base);
  line-height: var(--tw-leading, var(--text-base--line-height));
}
.text-lg {
  font-size: var(--text-lg);
  line-height: var(--tw-leading, var(--text-lg--line-height));
}
.text-sm {
  font-size: var(--text-sm);
  line-height: var(--tw-leading, var(--text-sm--line-height));
}
.text-xl {
  font-size: var(--text-xl);
  line-height: var(--tw-leading, var(--text-xl--line-height));
}
.text-xs {
  font-size: var(--text-xs);
  line-height: var(--tw-leading, var(--text-xs--line-height));
}
.font-bold {
  --tw-font-weight: var(--font-weight-bold);
  font-weight: var(--font-weight-bold);
}
.font-light {
  --tw-font-weight: var(--font-weight-light);
  font-weight: var(--font-weight-light);
}
.font-normal {
  --tw-font-weight: var(--font-weight-normal);
  font-weight: var(--font-weight-normal);
}
.font-semibold {
  --tw-font-weight: var(--font-weight-semibold);
  font-weight: var(--font-weight-semibold);
}
.text-\\[\\#1E1E1E\\] {
  color: #1E1E1E;
}
.text-\\[\\#79A2FF\\] {
  color: #79A2FF;
}
.text-\\[\\#144dd2\\] {
  color: #144dd2;
}
.text-\\[\\#1553E0\\] {
  color: #1553E0;
}
.text-\\[\\#081533\\] {
  color: #081533;
}
.text-\\[\\#081533\\]\\/70 {
  color: color-mix(in oklab, #081533 70%, transparent);
}
.text-\\[\\#887443\\] {
  color: #887443;
}
.text-\\[\\#FAFAFA\\]\\/60 {
  color: color-mix(in oklab, #FAFAFA 60%, transparent);
}
.text-black {
  color: var(--color-black);
}
.text-black\\/70 {
  color: color-mix(in srgb, #000 70%, transparent);
  @supports (color: color-mix(in lab, red, red)) {
    color: color-mix(in oklab, var(--color-black) 70%, transparent);
  }
}
.text-black\\/80 {
  color: color-mix(in srgb, #000 80%, transparent);
  @supports (color: color-mix(in lab, red, red)) {
    color: color-mix(in oklab, var(--color-black) 80%, transparent);
  }
}
.text-gray-600 {
  color: var(--color-gray-600);
}
.text-gray-700 {
  color: var(--color-gray-700);
}
.text-gray-800 {
  color: var(--color-gray-800);
}
.text-white {
  color: var(--color-white);
}
.text-white\\/60 {
  color: color-mix(in srgb, #fff 60%, transparent);
  @supports (color: color-mix(in lab, red, red)) {
    color: color-mix(in oklab, var(--color-white) 60%, transparent);
  }
}
.text-white\\/70 {
  color: color-mix(in srgb, #fff 70%, transparent);
  @supports (color: color-mix(in lab, red, red)) {
    color: color-mix(in oklab, var(--color-white) 70%, transparent);
  }
}
.text-white\\/80 {
  color: color-mix(in srgb, #fff 80%, transparent);
  @supports (color: color-mix(in lab, red, red)) {
    color: color-mix(in oklab, var(--color-white) 80%, transparent);
  }
}
.text-white\\/90 {
  color: color-mix(in srgb, #fff 90%, transparent);
  @supports (color: color-mix(in lab, red, red)) {
    color: color-mix(in oklab, var(--color-white) 90%, transparent);
  }
}
.text-white\\/95 {
  color: color-mix(in srgb, #fff 95%, transparent);
  @supports (color: color-mix(in lab, red, red)) {
    color: color-mix(in oklab, var(--color-white) 95%, transparent);
  }
}
.accent-\\[\\#887443\\] {
  accent-color: #887443;
}
.shadow-lg {
  --tw-shadow: 0 10px 15px -3px var(--tw-shadow-color, rgb(0 0 0 / 0.1)), 0 4px 6px -4px var(--tw-shadow-color, rgb(0 0 0 / 0.1));
  box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
}
.shadow-md {
  --tw-shadow: 0 4px 6px -1px var(--tw-shadow-color, rgb(0 0 0 / 0.1)), 0 2px 4px -2px var(--tw-shadow-color, rgb(0 0 0 / 0.1));
  box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
}
.shadow-sm {
  --tw-shadow: 0 1px 3px 0 var(--tw-shadow-color, rgb(0 0 0 / 0.1)), 0 1px 2px -1px var(--tw-shadow-color, rgb(0 0 0 / 0.1));
  box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
}
.shadow-xl {
  --tw-shadow: 0 20px 25px -5px var(--tw-shadow-color, rgb(0 0 0 / 0.1)), 0 8px 10px -6px var(--tw-shadow-color, rgb(0 0 0 / 0.1));
  box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
}
.filter {
  filter: var(--tw-blur,) var(--tw-brightness,) var(--tw-contrast,) var(--tw-grayscale,) var(--tw-hue-rotate,) var(--tw-invert,) var(--tw-saturate,) var(--tw-sepia,) var(--tw-drop-shadow,);
}
.backdrop-blur-\\[3px\\] {
  --tw-backdrop-blur: blur(3px);
  -webkit-backdrop-filter: var(--tw-backdrop-blur,) var(--tw-backdrop-brightness,) var(--tw-backdrop-contrast,) var(--tw-backdrop-grayscale,) var(--tw-backdrop-hue-rotate,) var(--tw-backdrop-invert,) var(--tw-backdrop-opacity,) var(--tw-backdrop-saturate,) var(--tw-backdrop-sepia,);
  backdrop-filter: var(--tw-backdrop-blur,) var(--tw-backdrop-brightness,) var(--tw-backdrop-contrast,) var(--tw-backdrop-grayscale,) var(--tw-backdrop-hue-rotate,) var(--tw-backdrop-invert,) var(--tw-backdrop-opacity,) var(--tw-backdrop-saturate,) var(--tw-backdrop-sepia,);
}
.transition-all {
  transition-property: all;
  transition-timing-function: var(--tw-ease, var(--default-transition-timing-function));
  transition-duration: var(--tw-duration, var(--default-transition-duration));
}
.transition-colors {
  transition-property: color, background-color, border-color, outline-color, text-decoration-color, fill, stroke, --tw-gradient-from, --tw-gradient-via, --tw-gradient-to;
  transition-timing-function: var(--tw-ease, var(--default-transition-timing-function));
  transition-duration: var(--tw-duration, var(--default-transition-duration));
}
.duration-100 {
  --tw-duration: 100ms;
  transition-duration: 100ms;
}
.duration-300 {
  --tw-duration: 300ms;
  transition-duration: 300ms;
}
.ease-in-out {
  --tw-ease: var(--ease-in-out);
  transition-timing-function: var(--ease-in-out);
}
.select-none {
  -webkit-user-select: none;
  -moz-user-select: none;
       user-select: none;
}
.hover\\:border-none {
  &:hover {
    @media (hover: hover) {
      --tw-border-style: none;
      border-style: none;
    }
  }
}
.hover\\:bg-\\[\\#0E2D60\\] {
  &:hover {
    @media (hover: hover) {
      background-color: #0E2D60;
    }
  }
}
.hover\\:bg-\\[\\#7A5F22\\] {
  &:hover {
    @media (hover: hover) {
      background-color: #7A5F22;
    }
  }
}
.hover\\:bg-\\[\\#1553E0\\] {
  &:hover {
    @media (hover: hover) {
      background-color: #1553E0;
    }
  }
}
.hover\\:bg-\\[\\#887443\\]\\/90 {
  &:hover {
    @media (hover: hover) {
      background-color: color-mix(in oklab, #887443 90%, transparent);
    }
  }
}
.hover\\:bg-\\[\\#d9d9d9\\] {
  &:hover {
    @media (hover: hover) {
      background-color: #d9d9d9;
    }
  }
}
.hover\\:bg-gray-50 {
  &:hover {
    @media (hover: hover) {
      background-color: var(--color-gray-50);
    }
  }
}
.hover\\:bg-gray-100 {
  &:hover {
    @media (hover: hover) {
      background-color: var(--color-gray-100);
    }
  }
}
.hover\\:text-\\[\\#887443\\] {
  &:hover {
    @media (hover: hover) {
      color: #887443;
    }
  }
}
.hover\\:text-black {
  &:hover {
    @media (hover: hover) {
      color: var(--color-black);
    }
  }
}
.hover\\:underline {
  &:hover {
    @media (hover: hover) {
      text-decoration-line: underline;
    }
  }
}
.disabled\\:opacity-50 {
  &:disabled {
    opacity: 50%;
  }
}
.sm\\:grid-cols-2 {
  @media (width >= 40rem) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
.md\\:mb-0 {
  @media (width >= 48rem) {
    margin-bottom: calc(var(--spacing) * 0);
  }
}
.md\\:flex {
  @media (width >= 48rem) {
    display: flex;
  }
}
.md\\:hidden {
  @media (width >= 48rem) {
    display: none;
  }
}
.md\\:flex-row {
  @media (width >= 48rem) {
    flex-direction: row;
  }
}
.lg\\:top-\\[-130px\\] {
  @media (width >= 64rem) {
    top: -130px;
  }
}
.lg\\:top-\\[-290px\\] {
  @media (width >= 64rem) {
    top: -290px;
  }
}
.lg\\:m-0 {
  @media (width >= 64rem) {
    margin: calc(var(--spacing) * 0);
  }
}
.lg\\:mt-4 {
  @media (width >= 64rem) {
    margin-top: calc(var(--spacing) * 4);
  }
}
.lg\\:mt-5 {
  @media (width >= 64rem) {
    margin-top: calc(var(--spacing) * 5);
  }
}
.lg\\:mt-15 {
  @media (width >= 64rem) {
    margin-top: calc(var(--spacing) * 15);
  }
}
.lg\\:mr-0 {
  @media (width >= 64rem) {
    margin-right: calc(var(--spacing) * 0);
  }
}
.lg\\:mr-8 {
  @media (width >= 64rem) {
    margin-right: calc(var(--spacing) * 8);
  }
}
.lg\\:mb-0 {
  @media (width >= 64rem) {
    margin-bottom: calc(var(--spacing) * 0);
  }
}
.lg\\:mb-1 {
  @media (width >= 64rem) {
    margin-bottom: calc(var(--spacing) * 1);
  }
}
.lg\\:mb-6 {
  @media (width >= 64rem) {
    margin-bottom: calc(var(--spacing) * 6);
  }
}
.lg\\:mb-12 {
  @media (width >= 64rem) {
    margin-bottom: calc(var(--spacing) * 12);
  }
}
.lg\\:mb-\\[20px\\] {
  @media (width >= 64rem) {
    margin-bottom: 20px;
  }
}
.lg\\:ml-0 {
  @media (width >= 64rem) {
    margin-left: calc(var(--spacing) * 0);
  }
}
.lg\\:ml-8 {
  @media (width >= 64rem) {
    margin-left: calc(var(--spacing) * 8);
  }
}
.lg\\:ml-10 {
  @media (width >= 64rem) {
    margin-left: calc(var(--spacing) * 10);
  }
}
.lg\\:ml-20 {
  @media (width >= 64rem) {
    margin-left: calc(var(--spacing) * 20);
  }
}
.lg\\:block {
  @media (width >= 64rem) {
    display: block;
  }
}
.lg\\:flex {
  @media (width >= 64rem) {
    display: flex;
  }
}
.lg\\:hidden {
  @media (width >= 64rem) {
    display: none;
  }
}
.lg\\:h-24 {
  @media (width >= 64rem) {
    height: calc(var(--spacing) * 24);
  }
}
.lg\\:h-40 {
  @media (width >= 64rem) {
    height: calc(var(--spacing) * 40);
  }
}
.lg\\:h-75 {
  @media (width >= 64rem) {
    height: calc(var(--spacing) * 75);
  }
}
.lg\\:h-\\[400px\\] {
  @media (width >= 64rem) {
    height: 400px;
  }
}
.lg\\:h-\\[850px\\] {
  @media (width >= 64rem) {
    height: 850px;
  }
}
.lg\\:h-\\[1490px\\] {
  @media (width >= 64rem) {
    height: 1490px;
  }
}
.lg\\:h-\\[2000px\\] {
  @media (width >= 64rem) {
    height: 2000px;
  }
}
.lg\\:h-fit {
  @media (width >= 64rem) {
    height: -moz-fit-content;
    height: fit-content;
  }
}
.lg\\:min-h-\\[2000px\\] {
  @media (width >= 64rem) {
    min-height: 2000px;
  }
}
.lg\\:w-100 {
  @media (width >= 64rem) {
    width: calc(var(--spacing) * 100);
  }
}
.lg\\:w-\\[400px\\] {
  @media (width >= 64rem) {
    width: 400px;
  }
}
.lg\\:w-\\[420px\\] {
  @media (width >= 64rem) {
    width: 420px;
  }
}
.lg\\:w-\\[500px\\] {
  @media (width >= 64rem) {
    width: 500px;
  }
}
.lg\\:w-\\[600px\\] {
  @media (width >= 64rem) {
    width: 600px;
  }
}
.lg\\:w-\\[768px\\] {
  @media (width >= 64rem) {
    width: 768px;
  }
}
.lg\\:w-\\[800px\\] {
  @media (width >= 64rem) {
    width: 800px;
  }
}
.lg\\:w-\\[850px\\] {
  @media (width >= 64rem) {
    width: 850px;
  }
}
.lg\\:w-\\[900px\\] {
  @media (width >= 64rem) {
    width: 900px;
  }
}
.lg\\:w-\\[1400px\\] {
  @media (width >= 64rem) {
    width: 1400px;
  }
}
.lg\\:w-auto {
  @media (width >= 64rem) {
    width: auto;
  }
}
.lg\\:w-full {
  @media (width >= 64rem) {
    width: 100%;
  }
}
.lg\\:max-w-\\[900px\\] {
  @media (width >= 64rem) {
    max-width: 900px;
  }
}
.lg\\:max-w-\\[1000px\\] {
  @media (width >= 64rem) {
    max-width: 1000px;
  }
}
.lg\\:min-w-\\[1024px\\] {
  @media (width >= 64rem) {
    min-width: 1024px;
  }
}
.lg\\:grid-cols-2 {
  @media (width >= 64rem) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
.lg\\:grid-cols-3 {
  @media (width >= 64rem) {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}
.lg\\:flex-col {
  @media (width >= 64rem) {
    flex-direction: column;
  }
}
.lg\\:flex-row {
  @media (width >= 64rem) {
    flex-direction: row;
  }
}
.lg\\:items-start {
  @media (width >= 64rem) {
    align-items: flex-start;
  }
}
.lg\\:justify-between {
  @media (width >= 64rem) {
    justify-content: space-between;
  }
}
.lg\\:bg-\\[\\#081533\\] {
  @media (width >= 64rem) {
    background-color: #081533;
  }
}
.lg\\:via-\\[\\#183f9a\\] {
  @media (width >= 64rem) {
    --tw-gradient-via: #183f9a;
    --tw-gradient-via-stops: var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-via) var(--tw-gradient-via-position), var(--tw-gradient-to) var(--tw-gradient-to-position);
    --tw-gradient-stops: var(--tw-gradient-via-stops);
  }
}
.lg\\:p-0 {
  @media (width >= 64rem) {
    padding: calc(var(--spacing) * 0);
  }
}
.lg\\:p-8 {
  @media (width >= 64rem) {
    padding: calc(var(--spacing) * 8);
  }
}
.lg\\:p-20 {
  @media (width >= 64rem) {
    padding: calc(var(--spacing) * 20);
  }
}
.lg\\:py-0 {
  @media (width >= 64rem) {
    padding-block: calc(var(--spacing) * 0);
  }
}
.lg\\:py-16 {
  @media (width >= 64rem) {
    padding-block: calc(var(--spacing) * 16);
  }
}
.lg\\:text-left {
  @media (width >= 64rem) {
    text-align: left;
  }
}
.lg\\:text-start {
  @media (width >= 64rem) {
    text-align: start;
  }
}
.lg\\:text-2xl {
  @media (width >= 64rem) {
    font-size: var(--text-2xl);
    line-height: var(--tw-leading, var(--text-2xl--line-height));
  }
}
.lg\\:text-5xl {
  @media (width >= 64rem) {
    font-size: var(--text-5xl);
    line-height: var(--tw-leading, var(--text-5xl--line-height));
  }
}
.lg\\:text-6xl {
  @media (width >= 64rem) {
    font-size: var(--text-6xl);
    line-height: var(--tw-leading, var(--text-6xl--line-height));
  }
}
.xl\\:hidden {
  @media (width >= 80rem) {
    display: none;
  }
}
.\\32 xl\\:hidden {
  @media (width >= 96rem) {
    display: none;
  }
}
@layer theme, base, components, utilities;
@layer theme {
  :root, :host {
    --font-sans: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji",
      "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
    --font-mono: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono",
      "Courier New", monospace;
    --color-blue-50: oklch(97% 0.014 254.604);
    --color-blue-500: oklch(62.3% 0.214 259.815);
    --color-gray-50: oklch(98.5% 0.002 247.839);
    --color-gray-100: oklch(96.7% 0.003 264.542);
    --color-gray-300: oklch(87.2% 0.01 258.338);
    --color-gray-600: oklch(44.6% 0.03 256.802);
    --color-gray-700: oklch(37.3% 0.034 259.733);
    --color-gray-800: oklch(27.8% 0.033 256.848);
    --color-black: #000;
    --color-white: #fff;
    --spacing: 0.25rem;
    --container-md: 28rem;
    --text-xs: 0.75rem;
    --text-xs--line-height: calc(1 / 0.75);
    --text-sm: 0.875rem;
    --text-sm--line-height: calc(1.25 / 0.875);
    --text-base: 1rem;
    --text-base--line-height: calc(1.5 / 1);
    --text-lg: 1.125rem;
    --text-lg--line-height: calc(1.75 / 1.125);
    --text-xl: 1.25rem;
    --text-xl--line-height: calc(1.75 / 1.25);
    --text-2xl: 1.5rem;
    --text-2xl--line-height: calc(2 / 1.5);
    --text-3xl: 1.875rem;
    --text-3xl--line-height: calc(2.25 / 1.875);
    --text-4xl: 2.25rem;
    --text-4xl--line-height: calc(2.5 / 2.25);
    --text-5xl: 3rem;
    --text-5xl--line-height: 1;
    --text-6xl: 3.75rem;
    --text-6xl--line-height: 1;
    --font-weight-light: 300;
    --font-weight-normal: 400;
    --font-weight-semibold: 600;
    --font-weight-bold: 700;
    --radius-xs: 0.125rem;
    --radius-md: 0.375rem;
    --radius-lg: 0.5rem;
    --radius-xl: 0.75rem;
    --radius-2xl: 1rem;
    --radius-3xl: 1.5rem;
    --ease-in-out: cubic-bezier(0.4, 0, 0.2, 1);
    --default-transition-duration: 150ms;
    --default-transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    --default-font-family: var(--font-sans);
    --default-mono-font-family: var(--font-mono);
  }
}
@layer base {
  *, ::after, ::before, ::backdrop, ::file-selector-button {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
    border: 0 solid;
  }
  html, :host {
    line-height: 1.5;
    -webkit-text-size-adjust: 100%;
    -moz-tab-size: 4;
      -o-tab-size: 4;
         tab-size: 4;
    font-family: var(--default-font-family, ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji");
    font-feature-settings: var(--default-font-feature-settings, normal);
    font-variation-settings: var(--default-font-variation-settings, normal);
    -webkit-tap-highlight-color: transparent;
  }
  hr {
    height: 0;
    color: inherit;
    border-top-width: 1px;
  }
  abbr:where([title]) {
    -webkit-text-decoration: underline dotted;
    text-decoration: underline dotted;
  }
  h1, h2, h3, h4, h5, h6 {
    font-size: inherit;
    font-weight: inherit;
  }
  a {
    color: inherit;
    -webkit-text-decoration: inherit;
    text-decoration: inherit;
  }
  b, strong {
    font-weight: bolder;
  }
  code, kbd, samp, pre {
    font-family: var(--default-mono-font-family, ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace);
    font-feature-settings: var(--default-mono-font-feature-settings, normal);
    font-variation-settings: var(--default-mono-font-variation-settings, normal);
    font-size: 1em;
  }
  small {
    font-size: 80%;
  }
  sub, sup {
    font-size: 75%;
    line-height: 0;
    position: relative;
    vertical-align: baseline;
  }
  sub {
    bottom: -0.25em;
  }
  sup {
    top: -0.5em;
  }
  table {
    text-indent: 0;
    border-color: inherit;
    border-collapse: collapse;
  }
  :-moz-focusring {
    outline: auto;
  }
  progress {
    vertical-align: baseline;
  }
  summary {
    display: list-item;
  }
  ol, ul, menu {
    list-style: none;
  }
  img, svg, video, canvas, audio, iframe, embed, object {
    display: block;
    vertical-align: middle;
  }
  img, video {
    max-width: 100%;
    height: auto;
  }
  button, input, select, optgroup, textarea, ::file-selector-button {
    font: inherit;
    font-feature-settings: inherit;
    font-variation-settings: inherit;
    letter-spacing: inherit;
    color: inherit;
    border-radius: 0;
    background-color: transparent;
    opacity: 1;
  }
  :where(select:is([multiple], [size])) optgroup {
    font-weight: bolder;
  }
  :where(select:is([multiple], [size])) optgroup option {
    padding-inline-start: 20px;
  }
  ::file-selector-button {
    margin-inline-end: 4px;
  }
  ::-moz-placeholder {
    opacity: 1;
  }
  ::placeholder {
    opacity: 1;
  }
  @supports (not (-webkit-appearance: -apple-pay-button))  or (contain-intrinsic-size: 1px) {
    ::-moz-placeholder {
      color: currentcolor;
      @supports (color: color-mix(in lab, red, red)) {
        color: color-mix(in oklab, currentcolor 50%, transparent);
      }
    }
    ::placeholder {
      color: currentcolor;
      @supports (color: color-mix(in lab, red, red)) {
        color: color-mix(in oklab, currentcolor 50%, transparent);
      }
    }
  }
  textarea {
    resize: vertical;
  }
  ::-webkit-search-decoration {
    -webkit-appearance: none;
  }
  ::-webkit-date-and-time-value {
    min-height: 1lh;
    text-align: inherit;
  }
  ::-webkit-datetime-edit {
    display: inline-flex;
  }
  ::-webkit-datetime-edit-fields-wrapper {
    padding: 0;
  }
  ::-webkit-datetime-edit, ::-webkit-datetime-edit-year-field, ::-webkit-datetime-edit-month-field, ::-webkit-datetime-edit-day-field, ::-webkit-datetime-edit-hour-field, ::-webkit-datetime-edit-minute-field, ::-webkit-datetime-edit-second-field, ::-webkit-datetime-edit-millisecond-field, ::-webkit-datetime-edit-meridiem-field {
    padding-block: 0;
  }
  :-moz-ui-invalid {
    box-shadow: none;
  }
  button, input:where([type="button"], [type="reset"], [type="submit"]), ::file-selector-button {
    -webkit-appearance: button;
       -moz-appearance: button;
            appearance: button;
  }
  ::-webkit-inner-spin-button, ::-webkit-outer-spin-button {
    height: auto;
  }
  [hidden]:where(:not([hidden="until-found"])) {
    display: none !important;
  }
}
@layer utilities;
:root {
  font-family: "SF Pro Display", system-ui, Avenir, Helvetica, Arial, sans-serif;
  line-height: 1.5;
  font-weight: 400;
  color-scheme: light dark;
  color: rgba(255, 255, 255, 0.87);
  background-color: #242424;
  font-synthesis: none;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
body {
  justify-content: center;
  align-items: center;
}
a {
  font-weight: 500;
  color: #646cff;
  text-decoration: inherit;
}
a:hover {
  color: #535bf2;
}
h1 {
  font-size: 3.2em;
  line-height: 1.1;
}
button {
  border-radius: 8px;
  border: 1px solid transparent;
  padding: 0.6em 1.2em;
  font-size: 1em;
  font-weight: 500;
  font-family: inherit;
  background-color: #1a1a1a;
  cursor: pointer;
  transition: border-color 0.25s;
}
button:hover {
  border-color: #646cff;
}
button:focus,
button:focus-visible {
  outline: 4px auto -webkit-focus-ring-color;
}
@media (prefers-color-scheme: light) {
  :root {
    color: #213547;
    background-color: #ffffff;
  }
  a:hover {
    color: #747bff;
  }
  button {
    background-color: #f9f9f9;
  }
}
@property --tw-rotate-x {
  syntax: "*";
  inherits: false;
}
@property --tw-rotate-y {
  syntax: "*";
  inherits: false;
}
@property --tw-rotate-z {
  syntax: "*";
  inherits: false;
}
@property --tw-skew-x {
  syntax: "*";
  inherits: false;
}
@property --tw-skew-y {
  syntax: "*";
  inherits: false;
}
@property --tw-space-y-reverse {
  syntax: "*";
  inherits: false;
  initial-value: 0;
}
@property --tw-space-x-reverse {
  syntax: "*";
  inherits: false;
  initial-value: 0;
}
@property --tw-border-style {
  syntax: "*";
  inherits: false;
  initial-value: solid;
}
@property --tw-gradient-position {
  syntax: "*";
  inherits: false;
}
@property --tw-gradient-from {
  syntax: "<color>";
  inherits: false;
  initial-value: #0000;
}
@property --tw-gradient-via {
  syntax: "<color>";
  inherits: false;
  initial-value: #0000;
}
@property --tw-gradient-to {
  syntax: "<color>";
  inherits: false;
  initial-value: #0000;
}
@property --tw-gradient-stops {
  syntax: "*";
  inherits: false;
}
@property --tw-gradient-via-stops {
  syntax: "*";
  inherits: false;
}
@property --tw-gradient-from-position {
  syntax: "<length-percentage>";
  inherits: false;
  initial-value: 0%;
}
@property --tw-gradient-via-position {
  syntax: "<length-percentage>";
  inherits: false;
  initial-value: 50%;
}
@property --tw-gradient-to-position {
  syntax: "<length-percentage>";
  inherits: false;
  initial-value: 100%;
}
@property --tw-font-weight {
  syntax: "*";
  inherits: false;
}
@property --tw-shadow {
  syntax: "*";
  inherits: false;
  initial-value: 0 0 #0000;
}
@property --tw-shadow-color {
  syntax: "*";
  inherits: false;
}
@property --tw-shadow-alpha {
  syntax: "<percentage>";
  inherits: false;
  initial-value: 100%;
}
@property --tw-inset-shadow {
  syntax: "*";
  inherits: false;
  initial-value: 0 0 #0000;
}
@property --tw-inset-shadow-color {
  syntax: "*";
  inherits: false;
}
@property --tw-inset-shadow-alpha {
  syntax: "<percentage>";
  inherits: false;
  initial-value: 100%;
}
@property --tw-ring-color {
  syntax: "*";
  inherits: false;
}
@property --tw-ring-shadow {
  syntax: "*";
  inherits: false;
  initial-value: 0 0 #0000;
}
@property --tw-inset-ring-color {
  syntax: "*";
  inherits: false;
}
@property --tw-inset-ring-shadow {
  syntax: "*";
  inherits: false;
  initial-value: 0 0 #0000;
}
@property --tw-ring-inset {
  syntax: "*";
  inherits: false;
}
@property --tw-ring-offset-width {
  syntax: "<length>";
  inherits: false;
  initial-value: 0px;
}
@property --tw-ring-offset-color {
  syntax: "*";
  inherits: false;
  initial-value: #fff;
}
@property --tw-ring-offset-shadow {
  syntax: "*";
  inherits: false;
  initial-value: 0 0 #0000;
}
@property --tw-blur {
  syntax: "*";
  inherits: false;
}
@property --tw-brightness {
  syntax: "*";
  inherits: false;
}
@property --tw-contrast {
  syntax: "*";
  inherits: false;
}
@property --tw-grayscale {
  syntax: "*";
  inherits: false;
}
@property --tw-hue-rotate {
  syntax: "*";
  inherits: false;
}
@property --tw-invert {
  syntax: "*";
  inherits: false;
}
@property --tw-opacity {
  syntax: "*";
  inherits: false;
}
@property --tw-saturate {
  syntax: "*";
  inherits: false;
}
@property --tw-sepia {
  syntax: "*";
  inherits: false;
}
@property --tw-drop-shadow {
  syntax: "*";
  inherits: false;
}
@property --tw-drop-shadow-color {
  syntax: "*";
  inherits: false;
}
@property --tw-drop-shadow-alpha {
  syntax: "<percentage>";
  inherits: false;
  initial-value: 100%;
}
@property --tw-drop-shadow-size {
  syntax: "*";
  inherits: false;
}
@property --tw-backdrop-blur {
  syntax: "*";
  inherits: false;
}
@property --tw-backdrop-brightness {
  syntax: "*";
  inherits: false;
}
@property --tw-backdrop-contrast {
  syntax: "*";
  inherits: false;
}
@property --tw-backdrop-grayscale {
  syntax: "*";
  inherits: false;
}
@property --tw-backdrop-hue-rotate {
  syntax: "*";
  inherits: false;
}
@property --tw-backdrop-invert {
  syntax: "*";
  inherits: false;
}
@property --tw-backdrop-opacity {
  syntax: "*";
  inherits: false;
}
@property --tw-backdrop-saturate {
  syntax: "*";
  inherits: false;
}
@property --tw-backdrop-sepia {
  syntax: "*";
  inherits: false;
}
@property --tw-duration {
  syntax: "*";
  inherits: false;
}
@property --tw-ease {
  syntax: "*";
  inherits: false;
}
@layer properties {
  @supports ((-webkit-hyphens: none) and (not (margin-trim: inline))) or ((-moz-orient: inline) and (not (color:rgb(from red r g b)))) {
    *, ::before, ::after, ::backdrop {
      --tw-rotate-x: initial;
      --tw-rotate-y: initial;
      --tw-rotate-z: initial;
      --tw-skew-x: initial;
      --tw-skew-y: initial;
      --tw-space-y-reverse: 0;
      --tw-space-x-reverse: 0;
      --tw-border-style: solid;
      --tw-gradient-position: initial;
      --tw-gradient-from: #0000;
      --tw-gradient-via: #0000;
      --tw-gradient-to: #0000;
      --tw-gradient-stops: initial;
      --tw-gradient-via-stops: initial;
      --tw-gradient-from-position: 0%;
      --tw-gradient-via-position: 50%;
      --tw-gradient-to-position: 100%;
      --tw-font-weight: initial;
      --tw-shadow: 0 0 #0000;
      --tw-shadow-color: initial;
      --tw-shadow-alpha: 100%;
      --tw-inset-shadow: 0 0 #0000;
      --tw-inset-shadow-color: initial;
      --tw-inset-shadow-alpha: 100%;
      --tw-ring-color: initial;
      --tw-ring-shadow: 0 0 #0000;
      --tw-inset-ring-color: initial;
      --tw-inset-ring-shadow: 0 0 #0000;
      --tw-ring-inset: initial;
      --tw-ring-offset-width: 0px;
      --tw-ring-offset-color: #fff;
      --tw-ring-offset-shadow: 0 0 #0000;
      --tw-blur: initial;
      --tw-brightness: initial;
      --tw-contrast: initial;
      --tw-grayscale: initial;
      --tw-hue-rotate: initial;
      --tw-invert: initial;
      --tw-opacity: initial;
      --tw-saturate: initial;
      --tw-sepia: initial;
      --tw-drop-shadow: initial;
      --tw-drop-shadow-color: initial;
      --tw-drop-shadow-alpha: 100%;
      --tw-drop-shadow-size: initial;
      --tw-backdrop-blur: initial;
      --tw-backdrop-brightness: initial;
      --tw-backdrop-contrast: initial;
      --tw-backdrop-grayscale: initial;
      --tw-backdrop-hue-rotate: initial;
      --tw-backdrop-invert: initial;
      --tw-backdrop-opacity: initial;
      --tw-backdrop-saturate: initial;
      --tw-backdrop-sepia: initial;
      --tw-duration: initial;
      --tw-ease: initial;
    }
  }
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA,gEA4EA;AA5EA,iBA4EA;AA5EA;EAAA,sBA4EA;EA5EA,SA4EA;EA5EA,UA4EA;EA5EA,eA4EA;AAAA;AA5EA;EAAA,gBA4EA;EA5EA,8BA4EA;EA5EA,gBA4EA;IA5EA,cA4EA;OA5EA,WA4EA;EA5EA,2JA4EA;EA5EA,mEA4EA;EA5EA,uEA4EA;EA5EA,wCA4EA;AAAA;AA5EA;EAAA,SA4EA;EA5EA,cA4EA;EA5EA,qBA4EA;AAAA;AA5EA;EAAA,yCA4EA;EA5EA,iCA4EA;AAAA;AA5EA;EAAA,kBA4EA;EA5EA,oBA4EA;AAAA;AA5EA;EAAA,cA4EA;EA5EA,gCA4EA;EA5EA,wBA4EA;AAAA;AA5EA;EAAA,mBA4EA;AAAA;AA5EA;EAAA,gJA4EA;EA5EA,wEA4EA;EA5EA,4EA4EA;EA5EA,cA4EA;AAAA;AA5EA;EAAA,cA4EA;AAAA;AA5EA;EAAA,cA4EA;EA5EA,cA4EA;EA5EA,kBA4EA;EA5EA,wBA4EA;AAAA;AA5EA;EAAA,eA4EA;AAAA;AA5EA;EAAA,WA4EA;AAAA;AA5EA;EAAA,cA4EA;EA5EA,qBA4EA;EA5EA,yBA4EA;AAAA;AA5EA;EAAA,aA4EA;AAAA;AA5EA;EAAA,wBA4EA;AAAA;AA5EA;EAAA,kBA4EA;AAAA;AA5EA;EAAA,gBA4EA;AAAA;AA5EA;EAAA,cA4EA;EA5EA,sBA4EA;AAAA;AA5EA;EAAA,eA4EA;EA5EA,YA4EA;AAAA;AA5EA;EAAA,aA4EA;EA5EA,8BA4EA;EA5EA,gCA4EA;EA5EA,uBA4EA;EA5EA,cA4EA;EA5EA,gBA4EA;EA5EA,6BA4EA;EA5EA,UA4EA;AAAA;AA5EA;EAAA,mBA4EA;AAAA;AA5EA;EAAA,0BA4EA;AAAA;AA5EA;EAAA,sBA4EA;AAAA;AA5EA;EAAA,UA4EA;AAAA;AA5EA;EAAA,UA4EA;AAAA;AA5EA;EAAA;IAAA,mBA4EA;IA5EA;MAAA,yDA4EA;IAAA;EAAA;EA5EA;IAAA,mBA4EA;IA5EA;MAAA,yDA4EA;IAAA;EAAA;AAAA;AA5EA;EAAA,gBA4EA;AAAA;AA5EA;EAAA,wBA4EA;AAAA;AA5EA;EAAA,eA4EA;EA5EA,mBA4EA;AAAA;AA5EA;EAAA,oBA4EA;AAAA;AA5EA;EAAA,UA4EA;AAAA;AA5EA;EAAA,gBA4EA;AAAA;AA5EA;EAAA,gBA4EA;AAAA;AA5EA;EAAA,0BA4EA;KA5EA,uBA4EA;UA5EA,kBA4EA;AAAA;AA5EA;EAAA,YA4EA;AAAA;AA5EA;EAAA,wBA4EA;AAAA;AA5EA;EAAA,kBA4EA;AAAA;AA5EA;EAAA,eA4EA;AAAA;AA5EA;EAAA,kBA4EA;AAAA;AA5EA;EAAA,gBA4EA;AAAA;AA5EA;EAAA,+BA4EA;AAAA;AA5EA;EAAA,6BA4EA;AAAA;AA5EA;EAAA,8BA4EA;AAAA;AA5EA;EAAA,WA4EA;AAAA;AA5EA;EAAA,WA4EA;AAAA;AA5EA;EAAA,+BA4EA;AAAA;AA5EA;EAAA,+BA4EA;AAAA;AA5EA;EAAA,cA4EA;AAAA;AA5EA;EAAA,8BA4EA;AAAA;AA5EA;EAAA,UA4EA;AAAA;AA5EA;EAAA,WA4EA;AAAA;AA5EA;EAAA,WA4EA;AAAA;AA5EA;EAAA,WA4EA;AAAA;AA5EA;EAAA,WA4EA;AAAA;AA5EA;EAAA,gCA4EA;AAAA;AA5EA;EAAA,gCA4EA;AAAA;AA5EA;EAAA,gCA4EA;AAAA;AA5EA;EAAA,gCA4EA;AAAA;AA5EA;EAAA,gCA4EA;AAAA;AA5EA;EAAA,gCA4EA;AAAA;AA5EA;EAAA,uCA4EA;AAAA;AA5EA;EAAA,wCA4EA;AAAA;AA5EA;EAAA,mBA4EA;AAAA;AA5EA;EAAA,sCA4EA;AAAA;AA5EA;EAAA,sCA4EA;AAAA;AA5EA;EAAA,sCA4EA;AAAA;AA5EA;EAAA,sCA4EA;AAAA;AA5EA;EAAA,sCA4EA;AAAA;AA5EA;EAAA,uCA4EA;AAAA;AA5EA;EAAA,oCA4EA;AAAA;AA5EA;EAAA,oCA4EA;AAAA;AA5EA;EAAA,oCA4EA;AAAA;AA5EA;EAAA,oCA4EA;AAAA;AA5EA;EAAA,oCA4EA;AAAA;AA5EA;EAAA,qCA4EA;AAAA;AA5EA;EAAA,qCA4EA;AAAA;AA5EA;EAAA,qCA4EA;AAAA;AA5EA;EAAA,sCA4EA;AAAA;AA5EA;EAAA,sCA4EA;AAAA;AA5EA;EAAA,sCA4EA;AAAA;AA5EA;EAAA,sCA4EA;AAAA;AA5EA;EAAA,sCA4EA;AAAA;AA5EA;EAAA,uCA4EA;AAAA;AA5EA;EAAA,uCA4EA;AAAA;AA5EA;EAAA,uCA4EA;AAAA;AA5EA;EAAA,uCA4EA;AAAA;AA5EA;EAAA,uCA4EA;AAAA;AA5EA;EAAA,uCA4EA;AAAA;AA5EA;EAAA,uCA4EA;AAAA;AA5EA;EAAA,uCA4EA;AAAA;AA5EA;EAAA,wCA4EA;AAAA;AA5EA;EAAA,wCA4EA;AAAA;AA5EA;EAAA,wCA4EA;AAAA;AA5EA;EAAA,oBA4EA;AAAA;AA5EA;EAAA,qCA4EA;AAAA;AA5EA;EAAA,qCA4EA;AAAA;AA5EA;EAAA,sCA4EA;AAAA;AA5EA;EAAA,sCA4EA;AAAA;AA5EA;EAAA,cA4EA;AAAA;AA5EA;EAAA,iBA4EA;AAAA;AA5EA;EAAA,aA4EA;AAAA;AA5EA;EAAA,aA4EA;AAAA;AA5EA;EAAA,aA4EA;AAAA;AA5EA;EAAA,oBA4EA;AAAA;AA5EA;EAAA,gCA4EA;AAAA;AA5EA;EAAA,gCA4EA;AAAA;AA5EA;EAAA,wBA4EA;AAAA;AA5EA;EAAA,gCA4EA;AAAA;AA5EA;EAAA,iCA4EA;AAAA;AA5EA;EAAA,iCA4EA;AAAA;AA5EA;EAAA,iCA4EA;AAAA;AA5EA;EAAA,iCA4EA;AAAA;AA5EA;EAAA,iCA4EA;AAAA;AA5EA;EAAA,iCA4EA;AAAA;AA5EA;EAAA,YA4EA;AAAA;AA5EA;EAAA,YA4EA;AAAA;AA5EA;EAAA,aA4EA;AAAA;AA5EA;EAAA,aA4EA;AAAA;AA5EA;EAAA,aA4EA;AAAA;AA5EA;EAAA,aA4EA;AAAA;AA5EA;EAAA,aA4EA;AAAA;AA5EA;EAAA,aA4EA;AAAA;AA5EA;EAAA,aA4EA;AAAA;AA5EA;EAAA,aA4EA;AAAA;AA5EA;EAAA,YA4EA;AAAA;AA5EA;EAAA,wBA4EA;EA5EA,mBA4EA;AAAA;AA5EA;EAAA,YA4EA;AAAA;AA5EA;EAAA,aA4EA;AAAA;AA5EA;EAAA,iBA4EA;AAAA;AA5EA;EAAA,qCA4EA;AAAA;AA5EA;EAAA,iBA4EA;AAAA;AA5EA;EAAA,kBA4EA;AAAA;AA5EA;EAAA,+BA4EA;AAAA;AA5EA;EAAA,+BA4EA;AAAA;AA5EA;EAAA,+BA4EA;AAAA;AA5EA;EAAA,yBA4EA;AAAA;AA5EA;EAAA,gCA4EA;AAAA;AA5EA;EAAA,gCA4EA;AAAA;AA5EA;EAAA,gCA4EA;AAAA;AA5EA;EAAA,gCA4EA;AAAA;AA5EA;EAAA,WA4EA;AAAA;AA5EA;EAAA,YA4EA;AAAA;AA5EA;EAAA,YA4EA;AAAA;AA5EA;EAAA,YA4EA;AAAA;AA5EA;EAAA,YA4EA;AAAA;AA5EA;EAAA,YA4EA;AAAA;AA5EA;EAAA,YA4EA;AAAA;AA5EA;EAAA,YA4EA;AAAA;AA5EA;EAAA,YA4EA;AAAA;AA5EA;EAAA,YA4EA;AAAA;AA5EA;EAAA,YA4EA;AAAA;AA5EA;EAAA,YA4EA;AAAA;AA5EA;EAAA,YA4EA;AAAA;AA5EA;EAAA,YA4EA;AAAA;AA5EA;EAAA,YA4EA;AAAA;AA5EA;EAAA,YA4EA;AAAA;AA5EA;EAAA,YA4EA;AAAA;AA5EA;EAAA,YA4EA;AAAA;AA5EA;EAAA,YA4EA;AAAA;AA5EA;EAAA,WA4EA;AAAA;AA5EA;EAAA,uBA4EA;EA5EA,kBA4EA;AAAA;AA5EA;EAAA,WA4EA;AAAA;AA5EA;EAAA,8BA4EA;AAAA;AA5EA;EAAA,gBA4EA;AAAA;AA5EA;EAAA,OA4EA;AAAA;AA5EA;EAAA,0GA4EA;AAAA;AA5EA;EAAA,eA4EA;AAAA;AA5EA;EAAA,gDA4EA;AAAA;AA5EA;EAAA,sBA4EA;AAAA;AA5EA;EAAA,mBA4EA;AAAA;AA5EA;EAAA,mBA4EA;AAAA;AA5EA;EAAA,uBA4EA;AAAA;AA5EA;EAAA,6BA4EA;AAAA;AA5EA;EAAA,8BA4EA;AAAA;AA5EA;EAAA,uBA4EA;AAAA;AA5EA;EAAA,yBA4EA;AAAA;AA5EA;EAAA,2BA4EA;AAAA;AA5EA;EAAA,6BA4EA;AAAA;AA5EA;EAAA,6BA4EA;AAAA;AA5EA;EAAA,6BA4EA;AAAA;AA5EA;EAAA,6BA4EA;AAAA;AA5EA;EAAA,6BA4EA;AAAA;AA5EA;EAAA;IAAA,uBA4EA;IA5EA,8EA4EA;IA5EA,sFA4EA;EAAA;AAAA;AA5EA;EAAA;IAAA,uBA4EA;IA5EA,8EA4EA;IA5EA,sFA4EA;EAAA;AAAA;AA5EA;EAAA;IAAA,uBA4EA;IA5EA,8EA4EA;IA5EA,sFA4EA;EAAA;AAAA;AA5EA;EAAA;IAAA,uBA4EA;IA5EA,+EA4EA;IA5EA,uFA4EA;EAAA;AAAA;AA5EA;EAAA;IAAA,uBA4EA;IA5EA,+EA4EA;IA5EA,uFA4EA;EAAA;AAAA;AA5EA;EAAA,iCA4EA;AAAA;AA5EA;EAAA,iCA4EA;AAAA;AA5EA;EAAA,iBA4EA;AAAA;AA5EA;EAAA,gBA4EA;AAAA;AA5EA;EAAA,gCA4EA;AAAA;AA5EA;EAAA,gCA4EA;AAAA;AA5EA;EAAA,mCA4EA;AAAA;AA5EA;EAAA,+BA4EA;AAAA;AA5EA;EAAA,+BA4EA;AAAA;AA5EA;EAAA,+BA4EA;AAAA;AA5EA;EAAA,+BA4EA;AAAA;AA5EA;EAAA,4CA4EA;EA5EA,2CA4EA;AAAA;AA5EA;EAAA,oCA4EA;EA5EA,iBA4EA;AAAA;AA5EA;EAAA,oCA4EA;EA5EA,iBA4EA;AAAA;AA5EA;EAAA,yCA4EA;EA5EA,uBA4EA;AAAA;AA5EA;EAAA,uBA4EA;EA5EA,kBA4EA;AAAA;AA5EA;EAAA,qBA4EA;AAAA;AA5EA;EAAA,qBA4EA;AAAA;AA5EA;EAAA,qBA4EA;AAAA;AA5EA;EAAA,qBA4EA;AAAA;AA5EA;EAAA,uBA4EA;AAAA;AA5EA;EAAA,6DA4EA;AAAA;AA5EA;EAAA,qBA4EA;AAAA;AA5EA;EAAA,6DA4EA;AAAA;AA5EA;EAAA,gCA4EA;AAAA;AA5EA;EAAA,mCA4EA;AAAA;AA5EA;EAAA,mCA4EA;AAAA;AA5EA;EAAA,mCA4EA;AAAA;AA5EA;EAAA,yBA4EA;AAAA;AA5EA;EAAA,yBA4EA;AAAA;AA5EA;EAAA,yBA4EA;AAAA;AA5EA;EAAA,yBA4EA;AAAA;AA5EA;EAAA,yBA4EA;AAAA;AA5EA;EAAA,yBA4EA;AAAA;AA5EA;EAAA,+DA4EA;AAAA;AA5EA;EAAA,+DA4EA;AAAA;AA5EA;EAAA,+DA4EA;AAAA;AA5EA;EAAA,+DA4EA;AAAA;AA5EA;EAAA,yBA4EA;AAAA;AA5EA;EAAA,8DA4EA;AAAA;AA5EA;EAAA,+DA4EA;AAAA;AA5EA;EAAA,sCA4EA;AAAA;AA5EA;EAAA,6BA4EA;AAAA;AA5EA;EAAA,oCA4EA;AAAA;AA5EA;EAAA,yCA4EA;EA5EA,2DA4EA;AAAA;AA5EA;EAAA,2BA4EA;EA5EA,8LA4EA;AAAA;AA5EA;EAAA,0BA4EA;EA5EA,4NA4EA;EA5EA,iDA4EA;AAAA;AA5EA;EAAA,yBA4EA;EA5EA,8LA4EA;AAAA;AA5EA;EAAA,yBA4EA;EA5EA,8LA4EA;AAAA;AA5EA;EAAA,iCA4EA;AAAA;AA5EA;EAAA,iCA4EA;AAAA;AA5EA;EAAA,iCA4EA;AAAA;AA5EA;EAAA,iCA4EA;AAAA;AA5EA;EAAA,iCA4EA;AAAA;AA5EA;EAAA,iCA4EA;AAAA;AA5EA;EAAA,iCA4EA;AAAA;AA5EA;EAAA,kCA4EA;AAAA;AA5EA;EAAA,kCA4EA;AAAA;AA5EA;EAAA,kCA4EA;AAAA;AA5EA;EAAA,wCA4EA;AAAA;AA5EA;EAAA,wCA4EA;AAAA;AA5EA;EAAA,wCA4EA;AAAA;AA5EA;EAAA,wCA4EA;AAAA;AA5EA;EAAA,wCA4EA;AAAA;AA5EA;EAAA,wCA4EA;AAAA;AA5EA;EAAA,yCA4EA;AAAA;AA5EA;EAAA,yCA4EA;AAAA;AA5EA;EAAA,uCA4EA;AAAA;AA5EA;EAAA,uCA4EA;AAAA;AA5EA;EAAA,uCA4EA;AAAA;AA5EA;EAAA,uCA4EA;AAAA;AA5EA;EAAA,uCA4EA;AAAA;AA5EA;EAAA,uCA4EA;AAAA;AA5EA;EAAA,wCA4EA;AAAA;AA5EA;EAAA,wCA4EA;AAAA;AA5EA;EAAA,qCA4EA;AAAA;AA5EA;EAAA,sCA4EA;AAAA;AA5EA;EAAA,kBA4EA;AAAA;AA5EA;EAAA,mBA4EA;AAAA;AA5EA;EAAA,gBA4EA;AAAA;AA5EA;EAAA,iBA4EA;AAAA;AA5EA;EAAA,0BA4EA;EA5EA,4DA4EA;AAAA;AA5EA;EAAA,0BA4EA;EA5EA,4DA4EA;AAAA;AA5EA;EAAA,0BA4EA;EA5EA,4DA4EA;AAAA;AA5EA;EAAA,0BA4EA;EA5EA,4DA4EA;AAAA;AA5EA;EAAA,2BA4EA;EA5EA,6DA4EA;AAAA;AA5EA;EAAA,yBA4EA;EA5EA,2DA4EA;AAAA;AA5EA;EAAA,yBA4EA;EA5EA,2DA4EA;AAAA;AA5EA;EAAA,yBA4EA;EA5EA,2DA4EA;AAAA;AA5EA;EAAA,yBA4EA;EA5EA,2DA4EA;AAAA;AA5EA;EAAA,yCA4EA;EA5EA,oCA4EA;AAAA;AA5EA;EAAA,0CA4EA;EA5EA,qCA4EA;AAAA;AA5EA;EAAA,2CA4EA;EA5EA,sCA4EA;AAAA;AA5EA;EAAA,6CA4EA;EA5EA,wCA4EA;AAAA;AA5EA;EAAA,cA4EA;AAAA;AA5EA;EAAA,cA4EA;AAAA;AA5EA;EAAA,cA4EA;AAAA;AA5EA;EAAA,cA4EA;AAAA;AA5EA;EAAA,cA4EA;AAAA;AA5EA;EAAA,oDA4EA;AAAA;AA5EA;EAAA,cA4EA;AAAA;AA5EA;EAAA,oDA4EA;AAAA;AA5EA;EAAA,yBA4EA;AAAA;AA5EA;EAAA,gDA4EA;EA5EA;IAAA,+DA4EA;EAAA;AAAA;AA5EA;EAAA,gDA4EA;EA5EA;IAAA,+DA4EA;EAAA;AAAA;AA5EA;EAAA,4BA4EA;AAAA;AA5EA;EAAA,4BA4EA;AAAA;AA5EA;EAAA,4BA4EA;AAAA;AA5EA;EAAA,yBA4EA;AAAA;AA5EA;EAAA,gDA4EA;EA5EA;IAAA,+DA4EA;EAAA;AAAA;AA5EA;EAAA,gDA4EA;EA5EA;IAAA,+DA4EA;EAAA;AAAA;AA5EA;EAAA,gDA4EA;EA5EA;IAAA,+DA4EA;EAAA;AAAA;AA5EA;EAAA,gDA4EA;EA5EA;IAAA,+DA4EA;EAAA;AAAA;AA5EA;EAAA,gDA4EA;EA5EA;IAAA,+DA4EA;EAAA;AAAA;AA5EA;EAAA,qBA4EA;AAAA;AA5EA;EAAA,+HA4EA;EA5EA,sIA4EA;AAAA;AA5EA;EAAA,6HA4EA;EA5EA,sIA4EA;AAAA;AA5EA;EAAA,0HA4EA;EA5EA,sIA4EA;AAAA;AA5EA;EAAA,gIA4EA;EA5EA,sIA4EA;AAAA;AA5EA;EAAA,0LA4EA;AAAA;AA5EA;EAAA,6BA4EA;EA5EA,wRA4EA;EA5EA,gRA4EA;AAAA;AA5EA;EAAA,wBA4EA;EA5EA,qFA4EA;EA5EA,2EA4EA;AAAA;AA5EA;EAAA,uKA4EA;EA5EA,qFA4EA;EA5EA,2EA4EA;AAAA;AA5EA;EAAA,oBA4EA;EA5EA,0BA4EA;AAAA;AA5EA;EAAA,oBA4EA;EA5EA,0BA4EA;AAAA;AA5EA;EAAA,6BA4EA;EA5EA,8CA4EA;AAAA;AA5EA;EAAA,yBA4EA;EA5EA,sBA4EA;OA5EA,iBA4EA;AAAA;AA5EA;EAAA;IAAA;MAAA,uBA4EA;MA5EA,kBA4EA;IAAA;EAAA;AAAA;AA5EA;EAAA;IAAA;MAAA,yBA4EA;IAAA;EAAA;AAAA;AA5EA;EAAA;IAAA;MAAA,yBA4EA;IAAA;EAAA;AAAA;AA5EA;EAAA;IAAA;MAAA,yBA4EA;IAAA;EAAA;AAAA;AA5EA;EAAA;IAAA;MAAA,+DA4EA;IAAA;EAAA;AAAA;AA5EA;EAAA;IAAA;MAAA,yBA4EA;IAAA;EAAA;AAAA;AA5EA;EAAA;IAAA;MAAA,sCA4EA;IAAA;EAAA;AAAA;AA5EA;EAAA;IAAA;MAAA,uCA4EA;IAAA;EAAA;AAAA;AA5EA;EAAA;IAAA;MAAA,cA4EA;IAAA;EAAA;AAAA;AA5EA;EAAA;IAAA;MAAA,yBA4EA;IAAA;EAAA;AAAA;AA5EA;EAAA;IAAA;MAAA,+BA4EA;IAAA;EAAA;AAAA;AA5EA;EAAA;IAAA,YA4EA;EAAA;AAAA;AA5EA;EAAA;IAAA,gDA4EA;EAAA;AAAA;AA5EA;EAAA;IAAA,uCA4EA;EAAA;AAAA;AA5EA;EAAA;IAAA,aA4EA;EAAA;AAAA;AA5EA;EAAA;IAAA,aA4EA;EAAA;AAAA;AA5EA;EAAA;IAAA,mBA4EA;EAAA;AAAA;AA5EA;EAAA;IAAA,WA4EA;EAAA;AAAA;AA5EA;EAAA;IAAA,WA4EA;EAAA;AAAA;AA5EA;EAAA;IAAA,gCA4EA;EAAA;AAAA;AA5EA;EAAA;IAAA,oCA4EA;EAAA;AAAA;AA5EA;EAAA;IAAA,oCA4EA;EAAA;AAAA;AA5EA;EAAA;IAAA,qCA4EA;EAAA;AAAA;AA5EA;EAAA;IAAA,sCA4EA;EAAA;AAAA;AA5EA;EAAA;IAAA,sCA4EA;EAAA;AAAA;AA5EA;EAAA;IAAA,uCA4EA;EAAA;AAAA;AA5EA;EAAA;IAAA,uCA4EA;EAAA;AAAA;AA5EA;EAAA;IAAA,uCA4EA;EAAA;AAAA;AA5EA;EAAA;IAAA,wCA4EA;EAAA;AAAA;AA5EA;EAAA;IAAA,mBA4EA;EAAA;AAAA;AA5EA;EAAA;IAAA,qCA4EA;EAAA;AAAA;AA5EA;EAAA;IAAA,qCA4EA;EAAA;AAAA;AA5EA;EAAA;IAAA,sCA4EA;EAAA;AAAA;AA5EA;EAAA;IAAA,sCA4EA;EAAA;AAAA;AA5EA;EAAA;IAAA,cA4EA;EAAA;AAAA;AA5EA;EAAA;IAAA,aA4EA;EAAA;AAAA;AA5EA;EAAA;IAAA,aA4EA;EAAA;AAAA;AA5EA;EAAA;IAAA,iCA4EA;EAAA;AAAA;AA5EA;EAAA;IAAA,iCA4EA;EAAA;AAAA;AA5EA;EAAA;IAAA,iCA4EA;EAAA;AAAA;AA5EA;EAAA;IAAA,aA4EA;EAAA;AAAA;AA5EA;EAAA;IAAA,aA4EA;EAAA;AAAA;AA5EA;EAAA;IAAA,cA4EA;EAAA;AAAA;AA5EA;EAAA;IAAA,cA4EA;EAAA;AAAA;AA5EA;EAAA;IAAA,wBA4EA;IA5EA,mBA4EA;EAAA;AAAA;AA5EA;EAAA;IAAA,kBA4EA;EAAA;AAAA;AA5EA;EAAA;IAAA,iCA4EA;EAAA;AAAA;AA5EA;EAAA;IAAA,YA4EA;EAAA;AAAA;AA5EA;EAAA;IAAA,YA4EA;EAAA;AAAA;AA5EA;EAAA;IAAA,YA4EA;EAAA;AAAA;AA5EA;EAAA;IAAA,YA4EA;EAAA;AAAA;AA5EA;EAAA;IAAA,YA4EA;EAAA;AAAA;AA5EA;EAAA;IAAA,YA4EA;EAAA;AAAA;AA5EA;EAAA;IAAA,YA4EA;EAAA;AAAA;AA5EA;EAAA;IAAA,YA4EA;EAAA;AAAA;AA5EA;EAAA;IAAA,aA4EA;EAAA;AAAA;AA5EA;EAAA;IAAA,WA4EA;EAAA;AAAA;AA5EA;EAAA;IAAA,WA4EA;EAAA;AAAA;AA5EA;EAAA;IAAA,gBA4EA;EAAA;AAAA;AA5EA;EAAA;IAAA,iBA4EA;EAAA;AAAA;AA5EA;EAAA;IAAA,iBA4EA;EAAA;AAAA;AA5EA;EAAA;IAAA,gDA4EA;EAAA;AAAA;AA5EA;EAAA;IAAA,gDA4EA;EAAA;AAAA;AA5EA;EAAA;IAAA,sBA4EA;EAAA;AAAA;AA5EA;EAAA;IAAA,mBA4EA;EAAA;AAAA;AA5EA;EAAA;IAAA,uBA4EA;EAAA;AAAA;AA5EA;EAAA;IAAA,8BA4EA;EAAA;AAAA;AA5EA;EAAA;IAAA,yBA4EA;EAAA;AAAA;AA5EA;EAAA;IAAA,0BA4EA;IA5EA,4NA4EA;IA5EA,iDA4EA;EAAA;AAAA;AA5EA;EAAA;IAAA,iCA4EA;EAAA;AAAA;AA5EA;EAAA;IAAA,iCA4EA;EAAA;AAAA;AA5EA;EAAA;IAAA,kCA4EA;EAAA;AAAA;AA5EA;EAAA;IAAA,uCA4EA;EAAA;AAAA;AA5EA;EAAA;IAAA,wCA4EA;EAAA;AAAA;AA5EA;EAAA;IAAA,gBA4EA;EAAA;AAAA;AA5EA;EAAA;IAAA,iBA4EA;EAAA;AAAA;AA5EA;EAAA;IAAA,0BA4EA;IA5EA,4DA4EA;EAAA;AAAA;AA5EA;EAAA;IAAA,0BA4EA;IA5EA,4DA4EA;EAAA;AAAA;AA5EA;EAAA;IAAA,0BA4EA;IA5EA,4DA4EA;EAAA;AAAA;AA5EA;EAAA;IAAA,aA4EA;EAAA;AAAA;AA5EA;EAAA;IAAA,aA4EA;EAAA;AAAA;AA5EA,yCA4EA;AA5EA;EAAA;IAAA;6DA4EA;IA5EA;8BA4EA;IA5EA,yCA4EA;IA5EA,4CA4EA;IA5EA,2CA4EA;IA5EA,4CA4EA;IA5EA,2CA4EA;IA5EA,2CA4EA;IA5EA,4CA4EA;IA5EA,4CA4EA;IA5EA,mBA4EA;IA5EA,mBA4EA;IA5EA,kBA4EA;IA5EA,qBA4EA;IA5EA,kBA4EA;IA5EA,sCA4EA;IA5EA,mBA4EA;IA5EA,0CA4EA;IA5EA,iBA4EA;IA5EA,uCA4EA;IA5EA,mBA4EA;IA5EA,0CA4EA;IA5EA,kBA4EA;IA5EA,yCA4EA;IA5EA,kBA4EA;IA5EA,sCA4EA;IA5EA,oBA4EA;IA5EA,2CA4EA;IA5EA,mBA4EA;IA5EA,yCA4EA;IA5EA,gBA4EA;IA5EA,0BA4EA;IA5EA,mBA4EA;IA5EA,0BA4EA;IA5EA,wBA4EA;IA5EA,yBA4EA;IA5EA,2BA4EA;IA5EA,uBA4EA;IA5EA,qBA4EA;IA5EA,qBA4EA;IA5EA,mBA4EA;IA5EA,oBA4EA;IA5EA,kBA4EA;IA5EA,oBA4EA;IA5EA,2CA4EA;IA5EA,oCA4EA;IA5EA,kEA4EA;IA5EA,uCA4EA;IA5EA,4CA4EA;EAAA;AAAA;AA5EA;EAAA;IAAA,sBA4EA;IA5EA,SA4EA;IA5EA,UA4EA;IA5EA,eA4EA;EAAA;EA5EA;IAAA,gBA4EA;IA5EA,8BA4EA;IA5EA,gBA4EA;MA5EA,cA4EA;SA5EA,WA4EA;IA5EA,2JA4EA;IA5EA,mEA4EA;IA5EA,uEA4EA;IA5EA,wCA4EA;EAAA;EA5EA;IAAA,SA4EA;IA5EA,cA4EA;IA5EA,qBA4EA;EAAA;EA5EA;IAAA,yCA4EA;IA5EA,iCA4EA;EAAA;EA5EA;IAAA,kBA4EA;IA5EA,oBA4EA;EAAA;EA5EA;IAAA,cA4EA;IA5EA,gCA4EA;IA5EA,wBA4EA;EAAA;EA5EA;IAAA,mBA4EA;EAAA;EA5EA;IAAA,gJA4EA;IA5EA,wEA4EA;IA5EA,4EA4EA;IA5EA,cA4EA;EAAA;EA5EA;IAAA,cA4EA;EAAA;EA5EA;IAAA,cA4EA;IA5EA,cA4EA;IA5EA,kBA4EA;IA5EA,wBA4EA;EAAA;EA5EA;IAAA,eA4EA;EAAA;EA5EA;IAAA,WA4EA;EAAA;EA5EA;IAAA,cA4EA;IA5EA,qBA4EA;IA5EA,yBA4EA;EAAA;EA5EA;IAAA,aA4EA;EAAA;EA5EA;IAAA,wBA4EA;EAAA;EA5EA;IAAA,kBA4EA;EAAA;EA5EA;IAAA,gBA4EA;EAAA;EA5EA;IAAA,cA4EA;IA5EA,sBA4EA;EAAA;EA5EA;IAAA,eA4EA;IA5EA,YA4EA;EAAA;EA5EA;IAAA,aA4EA;IA5EA,8BA4EA;IA5EA,gCA4EA;IA5EA,uBA4EA;IA5EA,cA4EA;IA5EA,gBA4EA;IA5EA,6BA4EA;IA5EA,UA4EA;EAAA;EA5EA;IAAA,mBA4EA;EAAA;EA5EA;IAAA,0BA4EA;EAAA;EA5EA;IAAA,sBA4EA;EAAA;EA5EA;IAAA,UA4EA;EAAA;EA5EA;IAAA,UA4EA;EAAA;EA5EA;IAAA;MAAA,mBA4EA;MA5EA;QAAA,yDA4EA;MAAA;IAAA;IA5EA;MAAA,mBA4EA;MA5EA;QAAA,yDA4EA;MAAA;IAAA;EAAA;EA5EA;IAAA,gBA4EA;EAAA;EA5EA;IAAA,wBA4EA;EAAA;EA5EA;IAAA,eA4EA;IA5EA,mBA4EA;EAAA;EA5EA;IAAA,oBA4EA;EAAA;EA5EA;IAAA,UA4EA;EAAA;EA5EA;IAAA,gBA4EA;EAAA;EA5EA;IAAA,gBA4EA;EAAA;EA5EA;IAAA,0BA4EA;OA5EA,uBA4EA;YA5EA,kBA4EA;EAAA;EA5EA;IAAA,YA4EA;EAAA;EA5EA;IAAA,wBA4EA;EAAA;AAAA;AA5EA,gBA4EA;AA5EA;EAAA,8EA4EA;EA5EA,gBA4EA;EA5EA,gBA4EA;EA5EA,wBA4EA;EA5EA,gCA4EA;EA5EA,yBA4EA;EA5EA,oBA4EA;EA5EA,kCA4EA;EA5EA,mCA4EA;EA5EA,kCA4EA;AAAA;AA5EA;EAAA,uBA4EA;EA5EA,mBA4EA;AAAA;AA5EA;EAAA,gBA4EA;EA5EA,cA4EA;EA5EA,wBA4EA;AAAA;AA5EA;EAAA,cA4EA;AAAA;AA5EA;EAAA,gBA4EA;EA5EA,gBA4EA;AAAA;AA5EA;EAAA,kBA4EA;EA5EA,6BA4EA;EA5EA,oBA4EA;EA5EA,cA4EA;EA5EA,gBA4EA;EA5EA,oBA4EA;EA5EA,yBA4EA;EA5EA,eA4EA;EA5EA,8BA4EA;AAAA;AA5EA;EAAA,qBA4EA;AAAA;AA5EA;;EAAA,0CA4EA;AAAA;AA5EA;EAAA;IAAA,cA4EA;IA5EA,yBA4EA;EAAA;EA5EA;IAAA,cA4EA;EAAA;EA5EA;IAAA,yBA4EA;EAAA;AAAA;AA5EA;EAAA,WA4EA;EA5EA,eA4EA;AAAA;AA5EA;EAAA,WA4EA;EA5EA,eA4EA;AAAA;AA5EA;EAAA,WA4EA;EA5EA,eA4EA;AAAA;AA5EA;EAAA,WA4EA;EA5EA,eA4EA;AAAA;AA5EA;EAAA,WA4EA;EA5EA,eA4EA;AAAA;AA5EA;EAAA,WA4EA;EA5EA,eA4EA;EA5EA,gBA4EA;AAAA;AA5EA;EAAA,WA4EA;EA5EA,eA4EA;EA5EA,gBA4EA;AAAA;AA5EA;EAAA,WA4EA;EA5EA,eA4EA;EA5EA,oBA4EA;AAAA;AA5EA;EAAA,WA4EA;EA5EA,eA4EA;AAAA;AA5EA;EAAA,iBA4EA;EA5EA,eA4EA;EA5EA,oBA4EA;AAAA;AA5EA;EAAA,iBA4EA;EA5EA,eA4EA;EA5EA,oBA4EA;AAAA;AA5EA;EAAA,iBA4EA;EA5EA,eA4EA;EA5EA,oBA4EA;AAAA;AA5EA;EAAA,WA4EA;EA5EA,eA4EA;AAAA;AA5EA;EAAA,WA4EA;EA5EA,eA4EA;AAAA;AA5EA;EAAA,6BA4EA;EA5EA,eA4EA;EA5EA,iBA4EA;AAAA;AA5EA;EAAA,6BA4EA;EA5EA,eA4EA;EA5EA,kBA4EA;AAAA;AA5EA;EAAA,6BA4EA;EA5EA,eA4EA;EA5EA,mBA4EA;AAAA;AA5EA;EAAA,WA4EA;EA5EA,eA4EA;AAAA;AA5EA;EAAA,WA4EA;EA5EA,eA4EA;EA5EA,wBA4EA;AAAA;AA5EA;EAAA,WA4EA;EA5EA,eA4EA;AAAA;AA5EA;EAAA,sBA4EA;EA5EA,eA4EA;EA5EA,mBA4EA;AAAA;AA5EA;EAAA,WA4EA;EA5EA,eA4EA;EA5EA,wBA4EA;AAAA;AA5EA;EAAA,WA4EA;EA5EA,eA4EA;AAAA;AA5EA;EAAA,sBA4EA;EA5EA,eA4EA;EA5EA,mBA4EA;AAAA;AA5EA;EAAA,WA4EA;EA5EA,eA4EA;AAAA;AA5EA;EAAA,WA4EA;EA5EA,eA4EA;EA5EA,wBA4EA;AAAA;AA5EA;EAAA,WA4EA;EA5EA,eA4EA;AAAA;AA5EA;EAAA,WA4EA;EA5EA,eA4EA;EA5EA,wBA4EA;AAAA;AA5EA;EAAA,WA4EA;EA5EA,eA4EA;AAAA;AA5EA;EAAA,kBA4EA;EA5EA,eA4EA;EA5EA,kBA4EA;AAAA;AA5EA;EAAA,WA4EA;EA5EA,eA4EA;EA5EA,mBA4EA;AAAA;AA5EA;EAAA,WA4EA;EA5EA,eA4EA;EA5EA,wBA4EA;AAAA;AA5EA;EAAA,WA4EA;EA5EA,eA4EA;AAAA;AA5EA;EAAA,WA4EA;EA5EA,eA4EA;AAAA;AA5EA;EAAA,WA4EA;EA5EA,eA4EA;AAAA;AA5EA;EAAA,WA4EA;EA5EA,eA4EA;AAAA;AA5EA;EAAA,WA4EA;EA5EA,eA4EA;AAAA;AA5EA;EAAA,WA4EA;EA5EA,eA4EA;AAAA;AA5EA;EAAA,WA4EA;EA5EA,eA4EA;AAAA;AA5EA;EAAA,WA4EA;EA5EA,eA4EA;AAAA;AA5EA;EAAA,WA4EA;EA5EA,eA4EA;AAAA;AA5EA;EAAA,WA4EA;EA5EA,eA4EA;AAAA;AA5EA;EAAA,WA4EA;EA5EA,eA4EA;AAAA;AA5EA;EAAA,sBA4EA;EA5EA,eA4EA;EA5EA,mBA4EA;AAAA;AA5EA;EAAA,WA4EA;EA5EA,eA4EA;AAAA;AA5EA;EAAA,WA4EA;EA5EA,eA4EA;AAAA;AA5EA;EAAA,WA4EA;EA5EA,eA4EA;AAAA;AA5EA;EAAA,WA4EA;EA5EA,eA4EA;AAAA;AA5EA;EAAA,WA4EA;EA5EA,eA4EA;AAAA;AA5EA;EAAA,WA4EA;EA5EA,eA4EA;AAAA;AA5EA;EAAA,WA4EA;EA5EA,eA4EA;AAAA;AA5EA;EAAA,WA4EA;EA5EA,eA4EA;AAAA;AA5EA;EAAA,WA4EA;EA5EA,eA4EA;AAAA;AA5EA;EAAA,WA4EA;EA5EA,eA4EA;AAAA;AA5EA;EAAA,WA4EA;EA5EA,eA4EA;AAAA;AA5EA;EAAA,WA4EA;EA5EA,eA4EA;AAAA;AA5EA;EAAA;IAAA;MAAA,sBA4EA;MA5EA,sBA4EA;MA5EA,sBA4EA;MA5EA,oBA4EA;MA5EA,oBA4EA;MA5EA,uBA4EA;MA5EA,uBA4EA;MA5EA,wBA4EA;MA5EA,+BA4EA;MA5EA,yBA4EA;MA5EA,wBA4EA;MA5EA,uBA4EA;MA5EA,4BA4EA;MA5EA,gCA4EA;MA5EA,+BA4EA;MA5EA,+BA4EA;MA5EA,+BA4EA;MA5EA,yBA4EA;MA5EA,sBA4EA;MA5EA,0BA4EA;MA5EA,uBA4EA;MA5EA,4BA4EA;MA5EA,gCA4EA;MA5EA,6BA4EA;MA5EA,wBA4EA;MA5EA,2BA4EA;MA5EA,8BA4EA;MA5EA,iCA4EA;MA5EA,wBA4EA;MA5EA,2BA4EA;MA5EA,4BA4EA;MA5EA,kCA4EA;MA5EA,kBA4EA;MA5EA,wBA4EA;MA5EA,sBA4EA;MA5EA,uBA4EA;MA5EA,wBA4EA;MA5EA,oBA4EA;MA5EA,qBA4EA;MA5EA,sBA4EA;MA5EA,mBA4EA;MA5EA,yBA4EA;MA5EA,+BA4EA;MA5EA,4BA4EA;MA5EA,8BA4EA;MA5EA,2BA4EA;MA5EA,iCA4EA;MA5EA,+BA4EA;MA5EA,gCA4EA;MA5EA,iCA4EA;MA5EA,6BA4EA;MA5EA,8BA4EA;MA5EA,+BA4EA;MA5EA,4BA4EA;MA5EA,sBA4EA;MA5EA,kBA4EA;IAAA;EAAA;AAAA","sourcesContent":["@import url(\"https://fonts.cdnfonts.com/css/sf-pro-display\");\n@import \"tailwindcss/preflight\";\n@tailwind utilities;\n@import \"tailwindcss\";\n\n:root {\n  font-family:\n    \"SF Pro Display\", system-ui, Avenir, Helvetica, Arial, sans-serif;\n  line-height: 1.5;\n  font-weight: 400;\n\n  color-scheme: light dark;\n  color: rgba(255, 255, 255, 0.87);\n  background-color: #242424;\n\n  font-synthesis: none;\n  text-rendering: optimizeLegibility;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\nbody {\n  /* margin: 0; */\n  /* min-height: 100vh; */\n  /* display: flex; */\n  justify-content: center;\n  align-items: center;\n  /* flex-direction: column; */\n  /* padding: 0 1em; */\n}\n\na {\n  font-weight: 500;\n  color: #646cff;\n  text-decoration: inherit;\n}\na:hover {\n  color: #535bf2;\n}\n\nh1 {\n  font-size: 3.2em;\n  line-height: 1.1;\n}\n\nbutton {\n  border-radius: 8px;\n  border: 1px solid transparent;\n  padding: 0.6em 1.2em;\n  font-size: 1em;\n  font-weight: 500;\n  font-family: inherit;\n  background-color: #1a1a1a;\n  cursor: pointer;\n  transition: border-color 0.25s;\n}\nbutton:hover {\n  border-color: #646cff;\n}\nbutton:focus,\nbutton:focus-visible {\n  outline: 4px auto -webkit-focus-ring-color;\n}\n\n@media (prefers-color-scheme: light) {\n  :root {\n    color: #213547;\n    background-color: #ffffff;\n  }\n  a:hover {\n    color: #747bff;\n  }\n  button {\n    background-color: #f9f9f9;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
